export const ja_about = {
  main1: "グラフィックで情報を、グラフィックにパワーを。",
  main2: "ビジュアル情報SNS「Ubiq」",
  sub: "Ubiqを使えば、グラフィカルなコンテンツで視覚的・直感的に情報を取得できます。経済コンテンツからハウツーコンテンツ、マンガや写真集まで、画像を使ったさまざまなコンテンツとクリエイターがあなたを待っています。"
}